import React from 'react'
import PropTypes from 'prop-types'

import ClientSearchListItem from "./ClientSearchListItem";

const ClientSearchList = (props) => {

    return (
        <div>
            {
                props.clients.map(client => <ClientSearchListItem project_id={props.project_id} client={client} onClientAdd={props.onClientAdd}/>)
            }
        </div>
    )

}

ClientSearchList.propTypes = {
    project_id: PropTypes.string.isRequired,
    clients: PropTypes.array.isRequired,
    onClientAdd: PropTypes.func.isRequired
}

export default ClientSearchList